import { Button } from '@mui/material';
import { getSelectorAttribute, integrationsPageSelectors } from '@vy/app-selectors';
import type { Control } from 'react-hook-form';
import { useConnectToStripe } from '../../hooks/connect-to-stripe';
import type { StripeRegisterFormValues } from '../StripeRegisterFormSchema';

interface Props {
  control: Control<StripeRegisterFormValues>;
}

export const StripeRegistrationFooter = ({ control }: Props) => {
  const connectToStripe = useConnectToStripe(control);

  const { handleSubmit } = control;
  const submitHandler = handleSubmit((formValues) => connectToStripe(formValues.apiToken));

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button
        variant="contained"
        onClick={submitHandler}
        {...getSelectorAttribute(integrationsPageSelectors.drawer.stripe.registration.connectButton)}
      >
        Connect to Stripe
      </Button>
    </div>
  );
};
